import React, { useState, useEffect } from "react";
import { Grid, Box, Button } from "@mui/material";
import { useLogger } from "../../../../contexts/LoggerContext";
import { TwoPointResult, FieldGoalPlayLog } from "../../../../types/LogTypes";

export const FGBTwoPointLog = ({ kickType }: { kickType: "PAT" | "FG" }) => {
  const {
    setCurrentPlayLog,
    currentPlayLog,
    clearSelections,
    gameSituation,
    setGameSituation,
  } = useLogger();
  const [twoPointResult, setTwoPointResult] = useState<TwoPointResult | null>(
    null
  );
  const [isConversionSuccess, setIsConversionSuccess] = useState<boolean | null>(null);


  useEffect(() => {
    setCurrentPlayLog({
      ...currentPlayLog,
      two_point_result: twoPointResult,
      pat: kickType === "PAT",
    } as FieldGoalPlayLog);
  }, [twoPointResult]);

  useEffect(() => {
    if (clearSelections) {
      setTwoPointResult(null);
      setIsConversionSuccess(null);
    }
  }, [clearSelections]);

  const handleConversionFailed = () => {
    if (isConversionSuccess === false) {
      // If already failed, reset to initial state
      setTwoPointResult(null);
      setIsConversionSuccess(null);
    } else {
      // Set to failed state
      setTwoPointResult("FAILED");
      setIsConversionSuccess(false);
    }
  };

  const handleConversionSuccess = () => {
    if (isConversionSuccess === true) {
      // If already successful, reset to initial state
      setTwoPointResult(null);
      setIsConversionSuccess(null);
      setGameSituation({
        ...gameSituation,
        opp_score: gameSituation.club_score - 2,
      });
    } else {
      // Set to success state
      setTwoPointResult("SUCCESS");
      setIsConversionSuccess(true);
      setGameSituation({
        ...gameSituation,
        opp_score: gameSituation.opp_score + 2,
      });
    }
  };

  return (
    <Box>
      <Grid container>
        <Grid item xs={12}>
          <Button
            variant={isConversionSuccess === true ? "contained" : "outlined"}
            color="success"
            onClick={handleConversionSuccess}
            sx={{ mr: 1 }}
          >
            Conversion Success
          </Button>
          <Button
            variant={isConversionSuccess === false ? "contained" : "outlined"}
            color="error"
            onClick={handleConversionFailed}
          >
            Conversion Failed
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};
